import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UiTranslateModule } from '@fcom/ui-translate';

import { IconsModule } from '../icons/icons.module';
import { TagComponent } from './tag.component';

@NgModule({
  declarations: [TagComponent],
  imports: [CommonModule, UiTranslateModule, IconsModule],
  exports: [TagComponent],
  providers: [],
})
export class TagModule {}
